export const EMAILS = {
  getAccess: "getaccess@clipboardhealth.com",
} as const;
